import { notify } from '@xcritical/notification';

import { INotificationParams } from './types';

export const handleCPNotification = ({
  type,
  message,
}: INotificationParams) => {
  switch (type) {
    case 'error': {
      notify.error(message);
      break;
    }
    case 'success': {
      notify.success(message);
      break;
    }
    default: {
      console.error(`Handler for this notification type=${type} is not found`);
    }
  }
};
